<template>
  <input :type="type" :value="value" :placeholder="placeholder" :class="getClasses()" />
</template>

<script>
export default {
  name: 'form-input',
  props: {
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    additionalClasses: {
      type: Array,
    },
    value: {
      type: String,
      required: false,
    },
  },
  methods: {
    getClasses() {
      return this.additionalClasses ? `form-input ${this.additionalClasses.join(' ')}` : 'form-input';
    },
  },
};
</script>
